import styled from 'styled-components';

export const ExperienceContainer = styled.div`
  width: 100%;
  max-width: 600px;
`;

export const SectionContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 2em;
`;

export const SectionHeader = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  padding-bottom: 2em;
`;

export const SectionDescription = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  padding-bottom: 2em;
`;

export const SectionContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 2em;

  > div {
    width: 100%;
  }
`;
